import * as api from '../api';

export const getUpdatesFromServer = (slug_id, sorting, pageNo) => {
  const endpoint = `/projects/${slug_id}/notifications`;
  const data = {
    params: {
      q: {
        filter: {},
        paging: {
          // Increased 100 -> 500 See https://github.com/sdesregistry/IH-Engage/issues/2418
          size: 500, // IMPORTANT: all news are now displayed on the first page
          page: pageNo,
        },
        sort: sorting,
      },
    },
  };
  return api.get(endpoint, data);
};
